import { render, staticRenderFns } from "./CrHeader.vue?vue&type=template&id=2c456f4d&scoped=true"
import script from "./CrHeader.vue?vue&type=script&lang=js"
export * from "./CrHeader.vue?vue&type=script&lang=js"
import style0 from "./CrHeader.vue?vue&type=style&index=0&id=2c456f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c456f4d",
  null
  
)

export default component.exports